import styles from "./styles.module.css";

export default function Terms() {
  return (
    // TODO https://github.com/mozilla/pdf.js
    <object data="terms.pdf" type="application/pdf" className={styles.terms}>
      Отображение документа не поддерживается в вашем браузере.
      <br />
      <a href="terms.pdf">Скачать документ</a>
    </object>
  );
}
